import moment from 'moment-timezone';

export class EnterpriseDashboardBudgetGroupedContract {
	/** Set by the datagrid when used as a grid row for a unique key. */
	public id?: string;

	public originContractId: string;
	public dbaName: string;
	public referenceDate: Date;
	public referenceBudgetCost: number;
	public actualCost: number;
	public currentBudgetCost: number;
	public varianceAmount: number;
	public variancePercent: number;
	public currentBudgetCostDiffPercent: number;
	public locationAddress1: string;
	public locationAddress2: string;
	public locationCity: string;
	public locationZipCode: string;
	public actualIsUsageEstimated: boolean;
	public actualIsTaxRateEstimated: boolean;
	public actualIsDeliveryRateEstimated: boolean;
	public actualIsSupplyCostEstimated: boolean;

	constructor(enterpriseDashboardBudgetGroupedContract?: EnterpriseDashboardBudgetGroupedContract) {
		Object.assign(this, enterpriseDashboardBudgetGroupedContract);

		this.referenceDate = this.referenceDate ? new Date(moment(this.referenceDate).format('MMM DD, YYYY 00:00:00 a')) : this.referenceDate;
	}
}
